import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getSupplierInvoicesCountByUtilityPerMonth, getMeterSupplierInvoices} from "../../api";
import { Grid } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import SupplierTableHeader from "../supplier-invoices/supplier-table-header";
import SupplierTableRow from "../supplier-invoices/supplier-table-row";
import {DateFilter} from "../../components/table/filters/date-filter";
import {collateUtilityData} from "../../helpers/chart-dataset-helpers";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ReactGA from 'react-ga';
function mapStateToProps(state) {
    return {

    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {

    };
}



class SupplierInvoices extends Component {

    constructor(props)
    {
        super(props);

        this.state = {
            dataProvider: new ApiDataProvider(getMeterSupplierInvoices, [this.props.customerId, this.props.siteKey, this.props.meterSiteKey]),
            countData: {},
            nettCostData: {}
        }
    }

    componentDidMount() {
        this.fetchData();
        ReactGA.pageview('Meter supplier invoices tab');
    }

    fetchData = () => {
        getSupplierInvoicesCountByUtilityPerMonth(this.props.customerId)
            .then((utilityData) => {
                this.setState({ countData: collateUtilityData(utilityData, "count"),
                    nettCostData: collateUtilityData(utilityData, "nettCost") })
            });
    }

    render() {
        return (
            <div className="main-container">
               
                <Grid padded stackable columns='equal'>
                   <Grid.Row>
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider} name="supplier-invoices" canExport={true}
                                                      filterComponent={DateFilter} 
                                                     contextData={{ customerId: this.props.customerId }}
                                                     headerComponent={SupplierTableHeader} rowComponent={SupplierTableRow} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const wrap = connect(mapStateToProps, mapDispatchToProps);
export default wrap(SupplierInvoices);